<template>
    <section class="flex">
        <div class="box flex-1 w100">
            <div class="box-content">
                <div class="flex column">
                    <div class="flex-1">
                        Nome: XXX
                    </div>
                    <div class="flex-1 margin-top-m">
                        Email: XXX
                    </div>
                    <div class="flex-1 margin-top-m">
                        Telefone: XXX
                    </div>
                    <div class="flex-1 margin-top-m">
                        Tags:
                        <div class="flex-1 margin-top-m">
                            yyyyyy
                        </div>
                    </div>
                    <div class="flex-1 margin-top-m">
                        Campos Personalizados:
                        <div class="flex-1 margin-top-m">
                            yyyyyy
                        </div>
                    </div>
                    <div class="flex-1 margin-top-m">
                        Campanhas:
                        <div class="flex-1 margin-top-m">
                            yyyyyy
                        </div>
                    </div>
                    <div class="flex-1 margin-top-m">
                        Automações:
                        <div class="flex-1 margin-top-m">
                            yyyyyy
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </section>
</template>

<script>
export default {
    name: 'contact-detail',
    components: {

    },
    data() {
        return {
            contact: {}
        }
    },
    mounted() {

    },

}
</script>